import Queue from "nq-js";

class LiveQueryUseCase {
  execute(query, type) {
    console.log("q", query, "t", type);
    return Queue.LiveQuery.subscribe(query, type);
  }
}

export default LiveQueryUseCase;
